import { render, staticRenderFns } from "./BankInHtmlTemplate.vue?vue&type=template&id=af97d5b4&scoped=true"
import script from "./BankInHtmlTemplate.vue?vue&type=script&lang=js"
export * from "./BankInHtmlTemplate.vue?vue&type=script&lang=js"
import style0 from "./BankInHtmlTemplate.vue?vue&type=style&index=0&id=af97d5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af97d5b4",
  null
  
)

export default component.exports